
  import {defineComponent} from "vue";
  import {mapGetters, mapMutations, mapState} from "vuex";

  export default defineComponent({
    name: 'sort-option-component',
    emits: ['load-new-item'],
    data() {
      return {
        showSortOptionPopup: false,
      }
    },
    computed: {
      ...mapState({
        sortOptionList: (state: any) => state.SortOptionStore.sortOptionList,
        selectedIndex: (state: any) => state.SortOptionStore.selectedIndex,
      }),
      ...mapGetters('SortOptionStore', [
        'getSortOptionName'
      ]),
    },
    methods: {
      toggleSortOptionPopup(): void {
        this.showSortOptionPopup = !this.showSortOptionPopup;
      },
      changeSortOption(index: number): void {
        if (index === this.selectedIndex) {
          return;
        }

        this.toggleSortOptionPopup();
        this.setSortOption(index);
        this.$emit('load-new-item');
      },
      ...mapMutations('SortOptionStore', [
        'setSortOption',
      ]),
    }
  });
